import { tableAnatomy } from "@chakra-ui/react/anatomy";
import { defineSlotRecipe } from "@chakra-ui/react/styled-system";

// Chakra's Table base slots, plus the `line` and `outline` variants, hard-code
// `bg: "bg"` on row/header — i.e. the page background. Inside a lifted surface
// (Card.Body, Dialog, Drawer, Popover) that paints a darker rectangle through
// the surface and breaks the elevation. Transparent rows inherit whatever
// surface they sit on.
export default defineSlotRecipe({
  slots: tableAnatomy.keys(),
  base: {
    row: {
      bg: "transparent",
    },
    header: {
      bg: "transparent",
    },
  },
  variants: {
    variant: {
      line: {
        row: {
          bg: "transparent",
        },
      },
      outline: {
        header: {
          bg: "transparent",
        },
      },
    },
  },
});
